import { Component, OnDestroy, OnInit } from '@angular/core';
import { NewBlank } from '../../../../models/new-blank.model';
import { StandardType } from '../../../../models/standard-type.model';
import { PrefixService } from '../../../../services/frefix.service';
import { StepsControllerService } from '../../../../services/steps-controller.service';
import { StandardTypesService } from '../../../../services/standard-types.service';
import { AdminService } from '../../../../services/admin.service';
import { UserService } from '../../../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import { EditQuestionComponent } from './edit-question-step-popup/edit-question.component';
import { ApiConnectService } from '../../../../services/api-connect.service';
import { Question } from '../../../../models/question.model';
import { StepTempControllerService } from '../../../../services/step-temp-controller.service';
import { StepTestingService } from '../opst-step-six/step-cteate-testing/step-testing.service';
import { Router } from '@angular/router';
import { AddChanglogComponent } from './add-changlog/add-changlog.component';
import * as moment from 'moment';
import { TreeGroupPosService } from '../tree-group-pos-service/tree-group-pos.service';
import { ViewDocxService } from '../../../../services/view-docx.service';
import { ViewDocxComponent } from '../../../views/view-docx/view-docx.component';
import { AddNewQuestionsComponent } from '../../../views/view-standard/popups/add-new-questions/add-new-questions.component';
import { Answer } from '../../../../models/answer.model';
import { User } from '../../../../models/user.model';
import { StepConfirmPopupComponent } from '../step-confirm-popup/step-confirm-popup.component';
import { EditStandardNumberPopupComponent } from './edit-standard-number-popup/edit-standard-number-popup.component';

@Component({
  selector: 'app-opst-step-eight',
  templateUrl: './opst-step-eight.component.html',
  styleUrls: ['./opst-step-eight.component.css']
})
export class OpstStepEightComponent implements OnInit, OnDestroy {
  hasSaveAction = false;
  isLoaded = true;
  thisStandard: any;
  newBlanks: NewBlank[] = [];
  removedUsersIDList: any[] = [];
  okModifyMsg = false;
  daysForFamiliarization = 5;
  thisStandardList;
  usersAndGroups: any;
  stringDate: string;
  acknowledgementDays = 5;
  acknowledgementDaysTemp = null;
  showDiscussionBtn = false;
  showTable = false;
  isReadOnly = false;
  goBtnIsClicked = false;
  isLoadedStep = false;
  tableUsers: any;
  selectedType: StandardType;
  groupStandardId: string;
  users: any;
  groups: any;
  groupsHead: any;
  isUploadDisabled = false;
  newRuName = '';
  newEnName = '';
  newRuAn = '';
  newEnAn = '';
  formData: FormData = new FormData();
  selectedForExecute: any = [];
  selectedGroupForExecute: any = [];
  selectedPosForExecute: any = [];
  showUserFTable = true;
  listDelBlanks = [];

  foundUser = false;
  foundPos = false;
  foundGroup = false;
  foundUserConfirm = false;
  foundPosConfirm = false;
  foundGroupConfirm = false;

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  globalQuestions: any = [];
  globalRusQuest: any = [];
  globalEngQuest: any = [];
  disSaveBtn = false;

  successFMsg = false;
  errorFHMsg = false;
  errorUnknowMsg = false;
  showAddQuestions = false;
  showQestions = false;
  showDessiminStn = false;
  showFilesAndBlanks = false;
  showChangeLog = false;
  showChangeLogs = false;
  errorNoUsersMsg = false;
  errorMessage = false;
  user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;
  flagNg = true;
  role;
  errorFHMsgPpt = false;
  errorFHMsgTxt = false;

  constructor(public prefixService: PrefixService,
    public stepsControllerService: StepsControllerService,
    public standardTypesService: StandardTypesService,
    private adminService: AdminService,
    private userService: UserService,
    public viewDocxService: ViewDocxService,
    private apiConnectService: ApiConnectService,
    private stepTempControllerService: StepTempControllerService,
    private modalService: NgbModal,
    private stepTestingService: StepTestingService,
    private router: Router,
    private treeGroupPosService: TreeGroupPosService) {
  }

  ngOnDestroy() {
    this.stepsControllerService.leaveComponent();
  }

  ngOnInit() {
  this.checkRole();
  document.getElementsByClassName('card-footer')[0].innerHTML = '';
  document.getElementsByClassName('card-footer')[1].innerHTML = '';
    // Data
    this.stringDate = moment().format('DD.MM.YYYY');

    this.thisStandard = this.stepsControllerService.getCurrentStandard();
    this.hasSaveAction = false;
    if (this.stepsControllerService.hasCurrentStandard()) {
      this.thisStandard = this.stepsControllerService.getCurrentStandard();
    } else {
      this.thisStandard = null;
      //this.stepsControllerService.setCurrentStandard(null);
      if(this.isAdmin && !this.isHead) {
        this.router.navigate(['/dashboard/admin/standards-management-admin']);
      }
      if (this.isAdmin && this.isHead) {
        this.router.navigate(['/dashboard/admin/all-standards-head']);
      } 
      if (!this.isAdmin && this.isHead) {
        this.router.navigate(['/dashboard/admin/all-standards-head-only']);
      } 
    }

    this.userService.getActiveUsers().subscribe(
      (response) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.users = response.body;
        }
      },
      () => {
        this.errorMessage = true;
      }
    );

    this.adminService.getAllGroups().subscribe(
      (response) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.groups = response.body;
        }
      },
      () => {
        this.errorMessage = true;
      }
    );

    this.standardTypesService.updateAllTypes();
    if(this.thisStandard) {
      this.newRuName = this.thisStandard.ruName;
      this.newEnName = this.thisStandard.enName;
      this.newRuAn = this.thisStandard.ruAnnotation;
      this.newEnAn = this.thisStandard.enAnnotation;

          // Установить выбранными пользователей для исполнения
    if (this.thisStandard.linkedUsers.length > 0) {
      for (const userExecute of this.thisStandard.linkedUsers) {
        this.selectItem(userExecute);
      }
    }

    // Установить выбранными группы для исполнения
    if (this.thisStandard.linkedGroups.length > 0) {
      for (const groupExecute of this.thisStandard.linkedGroups) {
        this.selectGroupItem(groupExecute);
      }
    }

    // Установить выбранными позиции для исполнения
    if (this.thisStandard.linkedPositions.length > 0) {
      for (const posExecute of this.thisStandard.linkedPositions) {
        this.selectPosItem(posExecute);
      }
    }
    }

    if(this.isAdmin) {
      this.getUserTable();
    }
    this.isLoaded = true;
  }

  change(data) {
		this.flagNg = data;
    if(data === false) {
      this.getUserTable();
    }
	}

  getUserTable() {
    this.isLoaded = false;
    this.isLoadedStep = false;
    // Get familiarize info:
    this.stepsControllerService.getFamiliarizedInfo(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (response) => {
        if (response.status === 200) {
          this.tableUsers = response.body;
          this.isLoaded = true;
          this.isLoadedStep = true;
          this.thisStandard.status = this.stepsControllerService.getCurrentStandard().status.toString();

          if (this.tableUsers.length > 0) {
            this.showTable = true;
          } else {
            this.showTable = false;
          }
        }
      },
      () => {
        this.isLoaded = true;
        this.isLoadedStep = true;
      }
    );
  }

  deleteUserFromStnd(user) {
    const modalRef = this.modalService.open(StepConfirmPopupComponent);
    modalRef.componentInstance.massage = 'CONFIRM_REMOVE';
    modalRef.componentInstance.paramOne = user.user.firstName + ' ' + user.user.lastName;
    modalRef.result.then((result) => {
      if (result === 'ok') {
        // удалить
        this.adminService.deleteUserFromStandard(this.stepsControllerService.getCurrentStandard().id, user.user.id).subscribe(
          (response: any) => {
            if (response.status === 200) {
              this.tableUsers.forEach(item => {
                if (item.user.id === user.user.id) {
                  const index = this.tableUsers.indexOf(item);
                  this.tableUsers.splice(index, 1);
                }
              });
            }
          }, () => {
          }
        );
      }
    });
  }

  checkRole() {
		this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
	}

  isValid() {
    return (
      this.newRuName !== '' && this.newEnName !== '' &&
      this.newRuAn !== '' && this.newEnAn !== '' &&
      this.formData.has('RU_DOC') &&
      this.checkListsLength());
  }

  checkListsLength() {
    return (this.selectedGroupForExecute.length > 0
      || this.selectedForExecute.length > 0
      || this.selectedPosForExecute.length > 0);
  }

  setType(typeID) {
    const typeObj = this.standardTypesService.getTypesList().find(i => i.id === typeID);
    this.standardTypesService.setSelectedType(typeObj);
    this.selectedType = typeObj;
  }

  // ПРОВЕРКА ВЫБРАН ЛИ ЭЛЕМЕНТ
  selectItem(user) {
    if (this.isSelectedUser(user)) {
      const index = this.selectedForExecute.findIndex(x => x.id === user.id);
      if (index !== -1) {
        this.selectedForExecute.splice(index, 1);
      }
    } else {
      this.selectedForExecute.push(user);
    }
  }

  selectPosItem(pos) {
    if (this.isSelectedPos(pos)) {
      const index = this.selectedPosForExecute.findIndex(x => x.id === pos.id);
      if (index !== -1) {
        this.selectedPosForExecute.splice(index, 1);
      }
    } else {
      this.selectedPosForExecute.push(pos);
    }
  }

  selectGroupItem(group) {
    if (this.isSelectedGroup(group)) {
      const index = this.selectedGroupForExecute.findIndex(x => x.id === group.id);
      if (index !== -1) {
        this.selectedGroupForExecute.splice(index, 1);
      }
    } else {
      this.selectedGroupForExecute.push(group);
    }
  }

  isSelectedUser(user) {
    this.foundUser = false;
    if (this.selectedForExecute.length > 0) {
      for (const grp of this.selectedForExecute) {
        if (grp !== null) {
          if (grp.id === user.id) {
            this.foundUser = true;
            break;
          }
        }
      }
    }
    return this.foundUser;
  }

  check() {
    let a = true;
    this.newBlanks.forEach(item => {
      if(!item.name || !item.formData) {
        a = false;
      } else {
        a =  true;
      }
    })
    return a;
  }

  isSelectedPos(pos) {
    this.foundPos = false;
    if (this.selectedPosForExecute.length > 0) {
      for (const grp of this.selectedPosForExecute) {
        if (grp !== null) {
          if (grp.id === pos.id) {
            this.foundPos = true;
            break;
          }
        }

      }
    }
    return this.foundPos;
  }

  isSelectedGroup(group) {
    this.foundGroup = false;
    if (this.selectedGroupForExecute.length > 0) {
      for (const grp of this.selectedGroupForExecute) {
        if (grp !== null) {
          if (grp.id === group.id) {
            this.foundGroup = true;
            break;
          }
        }
      }
    }
    return this.foundGroup;
  }

  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  deleteBlankFile(blank, key) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        if (key > -1) {
          this.thisStandard.blanks.splice(key, 1);
        }
        let obj = {
          fileId: blank.fileId
        }
        this.listDelBlanks.push(obj);
        // this.adminService.deleteBlankFromStandardTemp(blank, this.stepsControllerService.getTempParrentID()).subscribe(
        //   (response) => {
        //     if (response.status === 200) {
        //       const index = this.thisStandard.blanks.indexOf(blank);
        //       this.thisStandard.blanks.splice(index, 1);
        //     }
        //   },
        //   () => {
        //   }
        // );
      }
    });
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result: any) => {
      if (result === 'ok') {
        this.adminService.deleteFileFromStandardTemp(fileId, type, this.stepsControllerService.getTempParrentID()).subscribe(
          (response) => {
            if (response.status === 200) {
              switch (type) {
                case 'RU_DOC': {
                  this.thisStandard.ruDocId = null;
                  break;
                }
                case 'RU_PPT': {
                  this.thisStandard.ruPptId = null;
                  break;
                }
                case 'RU_PDF': {
                  this.thisStandard.ruPdfId = null;
                  break;
                }
                case 'EN_DOC': {
                  this.thisStandard.enDocId = null;
                  break;
                }
                case 'EN_PPT': {
                  this.thisStandard.enPptId = null;
                  break;
                }
                case 'EN_PDF': {
                  this.thisStandard.enPdfId = null;
                  break;
                }
              }
            }
          },
          () => {
          }
        );
      }
    });
  }

  deleteFilePresentation(fileId: string, type: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result: any) => {
      if (result === 'ok') {
        this.thisStandard.ruPptId = null;
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    });
  }

  deleteFileEdit(fileId: string, type: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result: any) => {
      if (result === 'ok') {
        this.thisStandard.ruFileLink = null;
        this.thisStandard.ruDocId = null;
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    });
  }


  fileChange(typeFile, event) {
    switch (typeFile) {
      case 'RU_PPT':
        if (event.target.files.length > 0) {
          this.fileRuPpt = event.target.files[0];
          this.isNewRuPpt = true;
        } else {
          this.fileRuPpt = null;
          this.isNewRuPpt = false;
        }
        break;
      case 'RU_DOC':
        const files = event.target.files;
        if (files[0].name.slice(files.length - 6) === '.docx') {
          this.errorFHMsgTxt = false;
          if (event.target.files.length > 0) {
            this.fileRuDoc = event.target.files[0];
            this.isNewRuDoc = true;
          } else {
            this.fileRuDoc = null;
            this.isNewRuDoc = false;
          }
        } else {
          this.errorFHMsgTxt = true;
        }
        break;
      case 'RU_PDF':
        if (event.target.files.length > 0) {
          this.fileRuPdf = event.target.files[0];
          this.isNewRuPdf = true;
        } else {
          this.fileRuPdf = null;
          this.isNewRuPdf = false;
        }
        break;
      case 'EN_PPT':
        if (event.target.files.length > 0) {
          this.fileEnPpt = event.target.files[0];
          this.isNewEnPpt = true;
        } else {
          this.fileEnPpt = null;
          this.isNewEnPpt = false;
        }
        break;
      case 'EN_DOC':
        if (event.target.files.length > 0) {
          this.fileEnDoc = event.target.files[0];
          this.isNewEnDoc = true;
        } else {
          this.fileEnDoc = null;
          this.isNewEnDoc = false;
        }
        break;
      case 'EN_PDF':
        if (event.target.files.length > 0) {
          this.fileEnPdf = event.target.files[0];
          this.isNewEnPdf = true;
        } else {
          this.fileEnPdf = null;
          this.isNewEnPdf = false;
        }
        break;
    }
  }

  uplodFileAfterEdit() {
      const formData: FormData = new FormData();
      formData.set('RU_DOC', this.fileRuDoc, this.fileRuDoc.name);
      this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
        () => {
          this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
            (response: any) => {
              this.thisStandard.ruDocId = response.body.ruFileLink;
              this.isUploadDisabled = false;
              this.presaAfterSave();
            },
            (err) => {
              this.isUploadDisabled = false;
            }
          );
        }, 
        (err) => {
          this.isUploadDisabled = false;
        }
      );
  }

  uplodFileAfterSave() {
    const formData: FormData = new FormData();
    formData.set('RU_PPT', this.fileRuPpt, this.fileRuPpt.name);
    this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
      (res: any) => {
        this.errorFHMsgPpt = false;
        this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
          (response: any) => {
            this.thisStandard.ruPptId = response.body.ruPptId;
            this.isUploadDisabled = false;
            this.blanksAfterSave();
          },
          (err) => {
            this.isUploadDisabled = false;
          }
        );
      },
      (err) => {
        this.errorFHMsgPpt = true;
        this.isUploadDisabled = false;
      }
    );
  }

  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  deleteFileDOCX(sid, fileLink, type, docId) {
    this.adminService.deleteTempDocxFileManuallyTemp(fileLink, this.stepsControllerService.getTempParrentID()).subscribe(
      (res: any) => {
        if (type === 'RU_DOC') {
          this.thisStandard.ruDoc = null;
          this.thisStandard.ruFileLink = null;
        } else if (type === 'EN_DOC') {
          this.thisStandard.enDoc = null;
          this.thisStandard.enFileLink = null;
        }
        if (docId) {
          this.deleteFile(docId, type);
        }
      },
      () => {
      }
    );

  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
    this.check();
  }

  cnhageBlankInfo(event, i){
		this.newBlanks[i].name = event;
		this.newBlanks[i].number = this.thisStandard.number + '_blank_' + (this.thisStandard.blanks.length + this.newBlanks.length + 1);
	}

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  saveBlank() {
    this.adminService.uploadBlankTemp(this.stepsControllerService.getTempParrentID(), this.newBlanks).subscribe(
      (response) => {
        if (response.status === 200) {
          this.tempSaveThisStandard();
        }
      }
    );
  }

  deleteBlank(key) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }


  isSelectedUserForRemove(uID) {
    let foundForRemove = false;
    if (this.removedUsersIDList.length > 0) {
      for (const rID of this.removedUsersIDList) {
        if (rID === uID) {
          foundForRemove = true;
          break;
        }
      }
    }
    return foundForRemove;
  }

  openNewQuestionsModal() {
    const modalRef = this.modalService.open(AddNewQuestionsComponent);
    modalRef.componentInstance.setTempStandard(this.thisStandard);
  }

  openEditStandardNumberModal() {
    const modalRef = this.modalService.open(EditStandardNumberPopupComponent);
    modalRef.componentInstance.initParams(
      this.stepsControllerService.getTempParrentID(),
      this.thisStandard.number
    );
    modalRef.result.then(
      (result) => {
        if (result && result.isSuccess) {
          this.thisStandard.number = result.newNumber;
        }
      },
      () => {}
    );
  }

  openEditQuestionModal(question: Question, lang: string) {
    const modalRef = this.modalService.open(EditQuestionComponent);
    modalRef.componentInstance.initParams(null, question, lang, this.thisStandard);
  }

  deleteQuestion(question: Question, lang: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTQ';
    modalRef.result.then((result) => {

      if (result === 'ok') {
        if (lang === 'RUSSIAN') {
          const index = this.thisStandard.questions.russian.indexOf(question);
          this.thisStandard.questions.russian.splice(index, 1);
          this.thisStandard.questions.english.splice(index, 1);
        } else if (lang === 'ENGLISH') {
          const index = this.thisStandard.questions.english.indexOf(question);
          this.thisStandard.questions.english.splice(index, 1);
          this.thisStandard.questions.russian.splice(index, 1);
        }
      }

    });
  }


  // -----------------------------------------------------------------------------------------------

  tempSaveThisStandard() {
    this.disSaveBtn = true;
    this.hasSaveAction = false;
    this.globalEngQuest = this.thisStandard.questions.english;
    this.globalRusQuest = this.thisStandard.questions.russian;

    // standardDisseminationPositions: this.treeGroupPosService.getReadeForServer()

    if (this.stepTestingService.getQuestionList().length > 0) {
      for (const qst of this.stepTestingService.getQuestionList()) {
        // Берем на русском вопросы
        let ruRight;
        switch (qst.rightAnswerRu) {
          case '1':
            ruRight = qst.answers[0].answerOneRu;
            break;
          case '2':
            ruRight = qst.answers[0].answerTwoRu;
            break;
          case '3':
            ruRight = qst.answers[0].answerThreeRu;
            break;
        }
        const ruQ = {
          questionText: qst.questionTextRu,
          rightAnswer: {
            answerText: ruRight
          },
          answers: [{
            answerText: qst.answers[0].answerOneRu
          },
          {
            answerText: qst.answers[0].answerTwoRu
          },
          {
            answerText: qst.answers[0].answerThreeRu
          }
          ]
        };
        this.globalRusQuest.push(ruQ);
        // Берем на английском вопросы
        let enRight;
        switch (qst.rightAnswerEn) {
          case '1':
            enRight = qst.answers[0].answerOneEn;
            break;
          case '2':
            enRight = qst.answers[0].answerTwoEn;
            break;
          case '3':
            enRight = qst.answers[0].answerThreeEn;
            break;
        }
        const enQ = {
          questionText: qst.questionTextEn,
          rightAnswer: {
            answerText: enRight
          },
          answers: [{
            answerText: qst.answers[0].answerOneEn
          },
          {
            answerText: qst.answers[0].answerTwoEn
          },
          {
            answerText: qst.answers[0].answerThreeEn
          }
          ]
        };
        this.globalEngQuest.push(enQ);
      }
    }

    const linkedGroups = [];
    if (this.selectedGroupForExecute.length > 0) {
      for (const item of this.selectedGroupForExecute) {
        if (item !== null) {
          linkedGroups.push({ id: item.id });
        }

      }
    }

    const linkedUsers = [];
    if (this.selectedForExecute.length > 0) {
      for (const item of this.selectedForExecute) {
        if (item !== null) {
          linkedUsers.push({ id: item.id });
        }
      }
    }

    const linkedPositions = [];
    if (this.selectedPosForExecute.length > 0) {
      for (const item of this.selectedPosForExecute) {
        if (item !== null) {
          linkedPositions.push({ id: item.id });
        }
      }
    }

    // {
    //   id: this.standardTypesService.getSelectedType().id,
    //     ruName: this.standardTypesService.getSelectedType().ruName,
    //   enName: this.standardTypesService.getSelectedType().enName,
    //   group: this.standardTypesService.getSelectedType().group
    // }

    if(!this.thisStandard.ruDocId) {
      var ruFileLink = this.thisStandard.ruFileLink;
    } else {
      var ruFileLink = this.thisStandard.ruDocId;
    }
  
    const tempDoneStandard = {
      blanks: this.listDelBlanks,
      number: this.thisStandard.number,
      ruName: this.newRuName,
      enName: this.newEnName,
      ruAnnotation: this.newRuAn,
      enAnnotation: this.newEnAn,
      standardType: {
        id: this.standardTypesService.getSelectedType().id,
        ruName: this.standardTypesService.getSelectedType().ruName,
        enName: this.standardTypesService.getSelectedType().enName
      },
      questions: {
        english: this.globalEngQuest,
        russian: this.globalRusQuest
      },
      linkedUsers: linkedUsers,
      linkedPositions: linkedPositions,
      linkedGroups: linkedGroups,
      familiarizationDays: null,
      ruFileLink: ruFileLink,
      ruPptId: this.thisStandard.ruPptId,
      groupsWithPositions: this.treeGroupPosService.getReadeForServer()
    };

    if (this.stepsControllerService.getEditActiveWithNotification()) {
      tempDoneStandard.familiarizationDays = this.daysForFamiliarization;
    }

  

    this.stepTempControllerService.saveTempStandard(tempDoneStandard, this.stepsControllerService.getTempParrentID()).subscribe(
      (res: any) => {
        this.save();
        this.stepTestingService.clearQuestions();
        this.hasSaveAction = true;
        this.disSaveBtn = false;
        this.successFMsg = true;
      },
      () => {
        this.successFMsg = false;
        this.hasSaveAction = false;
        this.disSaveBtn = false;
      }
    );
  }


  // -----------------------------------------------------

  goToStandardsListTemp() {
    this.stepTestingService.clearQuestions();
    this.stepsControllerService.leaveComponent();
    if(this.isAdmin && !this.isHead) {
      this.router.navigate(['/dashboard/admin/standards-management-admin']);
    }
    if(this.isAdmin && this.isHead) {
      this.router.navigate(['/dashboard/admin/all-standards-head']);
    }
    if(!this.isAdmin && this.isHead) {
      this.router.navigate(['/dashboard/admin/all-standards-head-only']);
    }
  }


  saveStandart() {
    this.publishStandard()
  }

  publishStandard() {
    this.successFMsg = false;
    this.errorFHMsg = false;
    this.errorUnknowMsg = false;
    this.errorNoUsersMsg = false;



      if (this.stepsControllerService.getEditActiveWithNotification()) {
        this.hasSaveAction = false;
        const modalRef = this.modalService.open(ConfirmationPopupComponent);
        modalRef.componentInstance.massage = 'Publish the standard?';
        modalRef.result.then((result) => {
          if (result === 'ok') {
            this.isLoaded = false;
            this.stepsControllerService.publishStandardNoNotify(this.stepsControllerService.getTempParrentID()).subscribe(
              (res: any) => {
                if (res.status === 200) {
                  this.isLoaded = true;
                  this.successFMsg = true;
                  this.goToStandardsListTemp();
                } else if (res.status === 500) {
                  this.isLoaded = true;
                  this.errorFHMsg = true;
                } else {
                  this.isLoaded = true;
                  this.errorUnknowMsg = true;
                }
              },
              (err) => {
                if (err.status === 500) {
                  this.isLoaded = true;
                  this.errorFHMsg = true;
                }
              }

            );
          }
        });
      } else {
        this.isLoaded = true;
        this.hasSaveAction = false;
        localStorage.removeItem('ChangeLogs');
        const modalRef = this.modalService.open(AddChanglogComponent);
        modalRef.componentInstance.setModalLogWindow(modalRef);
        modalRef.result.then((result) => {
          if (result === 'continue') {
            if(this.fileRuDoc) {
              this.uplodFileAfterEdit();
            } else {
              this.presaAfterSave();
            }
          }
        });
      }
  }

presaAfterSave() {
  if(this.fileRuPpt) {
    this.uplodFileAfterSave(); 
  } else {
    this.blanksAfterSave();
  }
}

blanksAfterSave() {
    if(this.newBlanks.length > 0) {
      this.saveBlank();
    } else {
      this.tempSaveThisStandard();
    }
  }

  save() {
    if (localStorage.getItem('ChangeLogs') !== null) {
      const logBody = {
        note: localStorage.getItem('ChangeLogs')
      };
      this.stepsControllerService.publishStandardWithNotify(this.stepsControllerService.getTempParrentID(), logBody).subscribe(
        (res: any) => {
          if (res.status === 200) {
            this.successFMsg = true;
            localStorage.removeItem('ChangeLogs');
            this.goToStandardsListTemp();
          } else if (res.status === 500) {
            this.errorFHMsg = true;
          } else {
            this.errorUnknowMsg = true;
          }
        },
        (err) => {
          localStorage.removeItem('ChangeLogs');
          if (err.status === 500) {
            this.errorFHMsg = true;
          }
        }
      );

    }
  }

  shBlock(s) {
    switch (s) {
      case 'saq':
        this.showAddQuestions = !this.showAddQuestions;
        break;
      case 'sq':
        this.showQestions = !this.showQestions;
        break;
      case 'sds':
        this.showDessiminStn = !this.showDessiminStn;
        break;
      case 'scl':
        this.showChangeLog = !this.showChangeLog;
        break;
      case 'sfab':
        this.showFilesAndBlanks = !this.showFilesAndBlanks;
        break;
      case 'sau':
        this.showChangeLogs = !this.showChangeLogs;
        break;
      case 'stou':
        this.showUserFTable = !this.showUserFTable;
        break;
    }
  }

  onChange() {
    if (this.daysForFamiliarization < 1) {
      this.daysForFamiliarization = 1;
    }
  }

    // uploadFile(typeFile) {
  //   this.isUploadDisabled = true;
  //   if (typeFile === 'RU_PDF') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileRuPdf, this.fileRuPdf.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.ruPdfId = response.body.ruPdfId;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       }, () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  //   if (typeFile === 'EN_PDF') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileEnPdf, this.fileEnPdf.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.enPdfId = response.body.enPdfId;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       }, () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  //   if (typeFile === 'EN_DOC') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileEnDoc, this.fileEnDoc.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.enDocId = response.body.enDocId;
  //             this.thisStandard.enPdfId = response.body.enPdfId;
  //             this.thisStandard.enFileLink = response.body.enFileLink;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       },
  //       () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  //   if (typeFile === 'EN_PPT') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileEnPpt, this.fileEnPpt.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.enPptId = response.body.enPptId;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       },
  //       () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  // }

}




// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/opst-step-eight.component.ts